import { Button, Group, Heading, Paragraph, Skeleton } from '@ingeniorforeningen/figurine-core';
import { replaceHostName, stripText } from '../../helpers/textsHelpers';
import { useIsColumn } from '../../hooks';

const floatingButtonStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: 20,
  right: 20,
  zIndex: 210,
};

type CaseOverviewPageHeadProps = {
  loading: boolean;
  header?: string;
  description?: string;
  caseButtonText?: string;
  caseButtonUrl?: string;
};

export const CaseOverviewPageHead = ({
  loading,
  header,
  description,
  caseButtonText,
  caseButtonUrl,
}: CaseOverviewPageHeadProps) => {
  const { isColumn } = useIsColumn();

  if (loading || !header || !description || !caseButtonText || !caseButtonUrl) {
    return (
      <>
        <Skeleton width="25%" height="3.5rem" />
        <Group my="md" justify="space-between" align="center" noWrap>
          <Skeleton width="65%" height="2.5em" />
          <Skeleton width="18%" height="3.25em" style={{ borderRadius: 32 }} />
        </Group>
      </>
    );
  }

  return (
    <>
      <Heading text={stripText(header)} type="h1" />
      <Group mb="xl" justify="space-between" align="center" noWrap>
        <Paragraph text={stripText(description)} mt="sm" />
        <Button
          text={stripText(caseButtonText)}
          style={isColumn ? floatingButtonStyle : {}}
          href={stripText(replaceHostName(caseButtonUrl))}
        />
      </Group>
    </>
  );
};
